import * as $ from 'jquery';
import {Global} from '../init-global';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');



export class RecipeList {

    protected $root:JQuery;
    protected isMobile: boolean;
    protected breakpoint:number = 1024;

    protected $container: JQuery;
    protected $kids: JQuery;
    protected $classic: JQuery;
    protected $party: JQuery;
    protected $nobun: JQuery;
    protected columnClass: string = 'l-recipe-list__column';


    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        // Set starting state according to layout mode
        this.$container  = $('.l-recipe-list__container', this.$root);
        this.$kids       = $('#menu-section-kids', this.$root);
        this.$classic    = $('#menu-section-classic', this.$root);
        this.$party      = $('#menu-section-party', this.$root);
        this.$nobun      = $('#menu-section-nobun', this.$root);

        this.refreshViewport();

        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
        let columnOne = $(Global.newTag('div', this.columnClass + ' ' + this.columnClass + '--left'));
        let columnTwo = $(Global.newTag('div', this.columnClass + ' ' + this.columnClass + '--right'));

        columnOne.append(this.$kids).append(this.$classic);
        columnTwo.append(this.$party).append(this.$nobun);

        this.$container.append(columnTwo).append(columnOne); // New order created but still semantically coherent
    }

    private initMobile = () => {
       	if ($('.' + this.columnClass).length) {
            this.$container
            .append(this.$kids)
            .append(this.$classic)
            .append(this.$party)
            .append(this.$nobun);

            $('.' + this.columnClass).remove();
        }
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}